/**
 * Stable per-user key for Product Education persistence.
 */
export function resolveEducationUserId(actor) {
  if (!actor) {
    return null;
  }

  if (actor.isGuest) {
    return "guest";
  }

  return (
    actor.profile_id ||
    actor.profileId ||
    actor.id ||
    actor.supabase_user_id ||
    null
  );
}
